import(/* webpackMode: "eager" */ "/codebuild/output/src329001973/src/top-ten/src/app/error.jsx");
